import { render, staticRenderFns } from "./AccountTypes.vue?vue&type=template&id=24d1f114&scoped=true"
import script from "./AccountTypes.vue?vue&type=script&lang=js"
export * from "./AccountTypes.vue?vue&type=script&lang=js"
import style0 from "./AccountTypes.vue?vue&type=style&index=0&id=24d1f114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1f114",
  null
  
)

export default component.exports